import { allPosts } from "../../../mocks/newsData";
import { Link } from "react-router-dom";

export default function NewsHero() {
  const featured = allPosts.find((p) => p.featured);
  if (!featured) return null;

  return (
    <section className="relative bg-cl-dark overflow-hidden pt-32 pb-16 md:pt-40 md:pb-20">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-cl-lime blur-[120px]" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-cl-green blur-[100px]" />
      </div>

      <div className="relative max-w-screen-xl mx-auto px-6 lg:px-10">
        {/* Label */}
        <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-6 thick-border cartoon-shadow-sm">
          <i className="ri-newspaper-line text-cl-dark text-xs"></i>
          <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Cleario News &amp; Guides</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Left — text */}
          <div>
            <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-4">
              Waste wisdom.<br />
              <span className="text-cl-lime">No waffle.</span>
            </h1>
            <p className="text-white/60 text-base md:text-lg font-semibold leading-relaxed mb-8 max-w-lg">
              Tips, industry news, and eco updates from the team that collects over a million items a year.
            </p>

            {/* Featured badge */}
            <div className="inline-flex items-center gap-2 bg-white/10 border-2 border-white/20 rounded-2xl px-4 py-2">
              <span className="w-2 h-2 rounded-full bg-cl-lime inline-block animate-pulse"></span>
              <span className="text-white/80 text-xs font-black uppercase tracking-wider">Latest Article Below</span>
            </div>
          </div>

          {/* Right — featured card */}
          <Link to={`/news/${featured.slug}`} className="group block cursor-pointer">
            <div className="bg-white rounded-3xl overflow-hidden cartoon-card transition-transform duration-300 group-hover:-translate-y-1">
              <div className="relative overflow-hidden" style={{ height: "220px" }}>
                <img
                  src={featured.image}
                  alt={featured.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 object-top"
                />
                <span className="absolute top-3 left-3 bg-cl-lime text-cl-dark text-xs font-black uppercase tracking-widest px-3 py-1 rounded-full border-2 border-cl-dark cartoon-shadow-sm">
                  Featured
                </span>
                <span className="absolute top-3 right-3 bg-white/90 text-cl-dark text-xs font-black px-3 py-1 rounded-full border-2 border-cl-dark">
                  {featured.category}
                </span>
              </div>
              <div className="p-6">
                <p className="text-cl-green text-xs font-black uppercase tracking-widest mb-2">{featured.date} · {featured.readTime}</p>
                <h2 className="text-cl-dark font-black text-xl leading-snug group-hover:text-cl-green transition-colors mb-2">
                  {featured.title}
                </h2>
                <p className="text-cl-dark/60 text-sm leading-relaxed font-semibold line-clamp-2">{featured.excerpt}</p>
                <div className="flex items-center gap-3 mt-4">
                  <div className="w-7 h-7 rounded-full overflow-hidden border-2 border-cl-dark flex-shrink-0">
                    <img src={featured.author.avatar} alt={featured.author.name} className="w-full h-full object-cover" />
                  </div>
                  <span className="text-xs font-black text-cl-dark/70">{featured.author.name}</span>
                  <span className="ml-auto text-cl-green font-black text-sm flex items-center gap-1">
                    Read <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
